import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
} from "@chakra-ui/react";
import GuidedScheduleEditor from "src/Manager/EventDetail/Nav/Marketing/ManagedCampaigns/components/GuidedScheduleEditor";
import { useEffect, useState } from "react";

export type ScheduleInput = {
  start_at: string;
  end_at: string;
};

type EditScheduleModalProps = {
  isOpen: boolean;
  isSaving?: boolean;
  /** IANA zone for schedule wall times (must match edit payload). */
  eventTimezone: string;
  initialSchedule: ScheduleInput;
  onClose: () => void;
  onSave: (schedule: ScheduleInput) => void | Promise<void>;
};

export default function EditScheduleModal({
  isOpen,
  isSaving = false,
  eventTimezone,
  initialSchedule,
  onClose,
  onSave,
}: EditScheduleModalProps) {
  const [schedule, setSchedule] = useState<ScheduleInput>(initialSchedule);

  useEffect(() => {
    if (!isOpen) return;
    setSchedule(initialSchedule);
  }, [initialSchedule, isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Schedule</ModalHeader>
        <ModalBody>
          <VStack align="stretch" spacing={4}>
            <GuidedScheduleEditor
              eventTimezone={eventTimezone}
              startAt={schedule.start_at}
              endAt={schedule.end_at}
              onChangeStartAt={(value) =>
                setSchedule((prev) => ({ ...prev, start_at: value }))
              }
              onChangeEndAt={(value) =>
                setSchedule((prev) => ({ ...prev, end_at: value }))
              }
            />
          </VStack>
        </ModalBody>
        <ModalFooter>
          <HStack spacing={3}>
            <Button variant="ghost" onClick={onClose} isDisabled={isSaving}>
              Cancel
            </Button>
            <Button
              bg="gray.900"
              color="white"
              _hover={{ bg: "gray.800" }}
              onClick={() => onSave(schedule)}
              isLoading={isSaving}
            >
              Save
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
